import { FC } from 'react';
import BasePageHeader from 'components/PageHeader';
import { getBookingListPageLink } from 'lib/links';
import * as track from 'lib/gaTracking/bookingDetailsPageEvents';

interface PageHeaderProps {
  isSSO: boolean;
  bookingRef: string;
}

const PageHeader: FC<PageHeaderProps> = ({ isSSO, bookingRef }) => (
  <BasePageHeader
    title="My booking"
    bookingRef={bookingRef}
    backLinkUrl={isSSO ? getBookingListPageLink() : undefined}
    backLinkTitle={isSSO ? 'Your hotel bookings' : undefined}
    onClickBackLink={track.yourHotelsReturnLinkSelected}
  />
);

export default PageHeader;
